if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector("form");
        this.form.querySelector("[name=id]").disabled = false;
        this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
        this.cart =
          document.querySelector("cart-notification") ||
          document.querySelector("cart-drawer");
        this.submitButton = this.querySelector('[type="submit"]');

        if (document.querySelector("cart-drawer"))
          this.submitButton.setAttribute("aria-haspopup", "dialog");

        this.hideErrors = this.dataset.hideErrors === "true";
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute("aria-disabled") === "true") return;
        //Returning from submit to display size swatches if not visible in PLP Tiles
        var plpIdentifier = this.closest('.card-wrapper');
        if (plpIdentifier && plpIdentifier.querySelector('.plp-tile') !== null) {
            var sizeVariantOptions = plpIdentifier.querySelector('.size-variant-options');
            if (sizeVariantOptions && sizeVariantOptions.offsetWidth === 0 && sizeVariantOptions.offsetHeight === 0) {
                if (sizeVariantOptions.querySelector('input[type="radio"]:checked') && sizeVariantOptions.querySelector('input[type="radio"]:checked').classList.contains('disabled')) {
                  var addToCartSpan = plpIdentifier.querySelector('.quick-add__submit span');
                  if (addToCartSpan) {
                      addToCartSpan.innerHTML = 'Sold Out';
                  }

                  var quickAddSubmit = plpIdentifier.querySelector('.quick-add__submit');
                  if (quickAddSubmit) {
                      quickAddSubmit.classList.add('sold-out');
                  }
                }
                sizeVariantOptions.style.display = 'flex';
                return;
            }
        }

        this.handleErrorMessage();

        this.submitButton.setAttribute("aria-disabled", true);
        this.submitButton.classList.add("loading");
        this.querySelector(".loading__spinner").classList.remove("hidden");

        const config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        delete config.headers["Content-Type"];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            "sections",
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append("sections_url", window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        if (plpIdentifier) {
          var plpQuantity = plpIdentifier.querySelector('.quick-add__submit').getAttribute('data-quantity');
          formData.append("quantity", plpQuantity);
        }

  
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: "product-form",
                productVariantId: formData.get("id"),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage =
                this.submitButton.querySelector(".sold-out-message");
              if (!soldOutMessage) return;
              this.submitButton.setAttribute("aria-disabled", true);
              this.submitButton.querySelector("span").classList.add("hidden");
              soldOutMessage.classList.remove("hidden");
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: "product-form",
                productVariantId: formData.get("id"),
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest("quick-add-modal");
            if (quickAddModal) {
              document.body.addEventListener(
                "modalClosed",
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove("loading");
            if (this.cart && this.cart.classList.contains("is-empty"))
              this.cart.classList.remove("is-empty");
            if (!this.error) this.submitButton.removeAttribute("aria-disabled");
            this.querySelector(".loading__spinner").classList.add("hidden");
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(".product-form__error-message-wrapper");
        if (!this.errorMessageWrapper) return;
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            ".product-form__error-message"
          );

        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}

// Function to show alert
function displayAlert(alertType, alertMsg) {
  var alertElement = document.querySelector(".alert-global");
  alertElement.classList.remove("d-none");
  alertElement.classList.add(alertType);
  var alertMsgElement = alertElement.querySelector(".alert-msg");
  alertMsgElement.textContent = alertMsg;

  setTimeout(function () {
    alertElement.classList.add("d-none");
    alertElement.classList.remove("sucess");
  }, 3000);
}

class Wishlist extends HTMLElement {
  constructor() {
    super();
    var customerID = this.querySelector(".customer-id").value;
    var productID = this.querySelector(".product-id").value;
    var productHandle = this.querySelector(".product-handle").value;
    var wishListIcon = this.querySelector(".card__wishlist__icon");
    var svg = this.querySelector(".svg-wishlist");
    wishListIcon.addEventListener("click", function (e) {
      var isInWishlist = wishListIcon.classList.contains("inWishlist");
      // alert(productID);
      // alert(customerID);
      // alert('hello');
      //alert(svg);
      // TODO: URL should be dynamic
      var url =
        "https://shopify-api-3cp3.onrender.com/customer/${customerID}/wishlistupdate";
      //var url = 'http://localhost:3000/customer/7683064561986/wishlistupdate';
      url = url.replace("${customerID}", customerID);
      var action = isInWishlist ? "delete" : "add";

      fetch(url, {
        method: "POST",
        body: JSON.stringify({
          action: action,
          productID: productHandle,
        }),
        headers: {
          "Content-type": "application/json; charset=UTF-8",
        },
        mode: "cors",
      })
        .then((response) => response.json())
        .then((responseText) => {
          // alert(responseText.message);
          displayAlert("success", responseText.message);

          if (responseText.success) {
            if (action === "add") {
              wishListIcon.classList.add("inWishlist");
              svg.setAttribute("fill", "#097fb3");
            } else {
              wishListIcon.classList.remove("inWishlist");
              svg.setAttribute("fill", "none");
            }
          }
        })
        .catch((e) => {
          displayAlert("danger", "Unable to add product to wishlist");
          console.log(e);
        });
    });
  }
}
customElements.define("create-wishlist-icon", Wishlist);
